import { Icon } from '@/icons'
import styles from './BackButton.module.scss'
import { FC } from 'react'

interface BackButtonProps {
  onClick: () => void
}
export const BackButton: FC<BackButtonProps> = ({ onClick }) => {
  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      data-testid="authBackButton"
    >
      <Icon name="chevronLeft" width={20} height={20} className={styles.icon} />
      Вернуться назад
    </button>
  )
}
